<template>
  <v-app id="inspire" class="!bg-[#e9e9e9]">
    <v-main>
      <div class="p-[58px_68px_40px]">
        <section class="flex justify-between items-start mb-4">
          <div>
            <a
              @click.prevent="goBack"
              style="color: inherit; cursor: pointer; text-decoration: none"
              class="d-flex align-center d-inline-flex"
            >
              <v-icon size="20" class="mr-1">mdi-arrow-u-left-bottom</v-icon>
              <span style="text-decoration: underline">voltar</span>
            </a>
            <h1 class="font-bold mt-2 text-5xl">{{ roteiro.titulo }}</h1>
            <div class="text-lg mt-2 flex flex-col">
              <span v-if="projeto" class="font-bold">
                Projeto: <span class="font-medium">{{ projeto.nome }}</span>
              </span>
              <span v-if="projeto" class="font-bold">
                Validação:
                <span class="font-medium">{{ projeto.validacao }}</span>
              </span>
            </div>
            <div class="mt-6">
              <p>
                {{ projeto.descricao }}
              </p>
              <p class="mt-6">
                Link de acesso:
                <a :href="roteiro.link" target="_blank" class="text-blue-500">
                  {{ roteiro.link }}
                </a>
              </p>
            </div>
          </div>

          <div class="flex gap-3.5 mt-2.5">
            <template
              v-if="userType !== 'Desenvolvedor' && userType !== 'Coordenador'"
            >
              <v-btn
                class="h-[34px] rounded-[9px] text-xs font-extrabold normal-case bg-[#efb4b4] text-[#8a1010]"
                @click="solicitarCorrecoes"
              >
                <v-icon size="16" class="mr-2">mdi-close-circle</v-icon>
                Solicitar Correções
              </v-btn>

              <v-btn
                class="h-[34px] rounded-[9px] text-xs font-extrabold normal-case bg-[#ccebc3] text-[#0f6b2c]"
                @click="aprovarRoteiro"
              >
                <v-icon size="16" class="mr-2">mdi-check-circle</v-icon>
                Aprovar Roteiro
              </v-btn>
            </template>
            <v-btn
              v-else-if="userType === 'Desenvolvedor'"
              color="primary"
              variant="flat"
              prepend-icon="mdi-pencil"
              @click="irParaEdicao"
            >
              Editar Roteiro
            </v-btn>
          </div>
        </section>

        <!-- Loading State -->
        <div
          v-if="isLoading"
          class="py-12 text-center text-gray-500 font-medium"
        >
          <v-progress-circular
            indeterminate
            color="primary"
            class="mb-4"
            size="64"
          ></v-progress-circular>
          <p>Carregando dados do roteiro...</p>
        </div>

        <section v-else class="block max-w-[900px] mx-auto">
          <div class="flex flex-col gap-[26px]">
            <article
              v-for="(funcionalidade, index) in funcionalidades"
              :key="funcionalidade.id"
              class="min-h-[300px] grid grid-cols-[46px_1fr] mb-[26px]"
            >
              <div
                class="bg-[#004984] text-white rounded-l-md text-[26px] font-extrabold flex items-center justify-center"
              >
                {{ index + 1 }}
              </div>

              <div
                class="bg-white border border-[#d5d5d5] border-l-0 rounded-r-md p-[17px_18px]"
              >
                <div class="border border-[#d9d9d9] rounded p-3.5 mb-[13px]">
                  <h3
                    class="m-0 mb-2 text-[#2f2f2f] text-[17px] font-extrabold"
                  >
                    {{ funcionalidade.titulo }}
                  </h3>

                  <p class="m-0 text-[#444444] text-[13px] leading-[1.45]">
                    <strong>Objetivo da funcionalidade:</strong>
                    {{ funcionalidade.objetivo }}
                  </p>

                  <p
                    class="m-0 mt-2 text-[#444444] text-[13px] leading-[1.45]"
                    v-if="funcionalidade.comoAcessar"
                  >
                    <strong>Como acessar:</strong>
                    {{ funcionalidade.comoAcessar }}
                  </p>
                </div>

                <div
                  class="grid grid-cols-1 gap-5 mb-[13px]"
                  v-if="
                    funcionalidade.imagens && funcionalidade.imagens.length > 0
                  "
                >
                  <div
                    class="w-full h-auto min-h-[200px] max-h-[500px] flex items-center justify-center rounded overflow-hidden"
                    style="background-color: transparent"
                    v-for="imagem in funcionalidade.imagens"
                    :key="imagem.id_imagem"
                  >
                    <img
                      :src="imagem.link_imagem"
                      style="
                        width: 100%;
                        max-height: 500px;
                        object-fit: contain;
                      "
                    />
                  </div>
                </div>

                <div
                  class="min-h-[90px] border border-[#c2cbd6] border-l-[3px] border-l-[#004984] bg-[#f7fafc] rounded p-4 text-[#2d3748] text-[13px] leading-[1.5]"
                >
                  {{ funcionalidade.descricao }}
                </div>
              </div>
            </article>
          </div>

          <aside
            :class="[
              'fixed bottom-6 right-6 w-[360px] max-h-[calc(100vh-100px)] bg-white rounded-xl shadow-2xl overflow-hidden flex flex-col z-[1000] transition-all duration-300 max-[600px]:w-[calc(100vw-32px)] max-[600px]:right-4 max-[600px]:bottom-4',
              minimizouComentarios ? 'h-[54px]' : 'h-[480px]',
            ]"
          >
            <div
              class="h-[54px] bg-[#004984] text-white text-[17px] font-extrabold flex justify-between items-center w-full px-[22px]"
              style="cursor: pointer; user-select: none"
              @click="minimizouComentarios = !minimizouComentarios"
            >
              <div class="flex items-center">
                <v-icon size="20" class="mr-2" color="white"
                  >mdi-comment-multiple</v-icon
                >
                <span class="text-base font-semibold p-3">Comentários</span>
              </div>
              <v-icon color="white">{{
                minimizouComentarios ? 'mdi-chevron-up' : 'mdi-chevron-down'
              }}</v-icon>
            </div>

            <div class="comments-body flex-1 p-5 overflow-y-auto">
              <div
                v-for="comentario in comentarios"
                :key="comentario.id_comentario"
                class="flex flex-col items-start mb-[38px]"
              >
                <small class="text-[#777777] text-[9px] mb-2">{{
                  comentario.autor
                }}</small>

                <div
                  class="max-w-[310px] rounded-[24px] p-[16px_20px] text-xs leading-[1.35] bg-[#e8ebf0] text-[#004984]"
                >
                  {{ comentario.texto }}
                </div>
              </div>
            </div>

            <div
              class="h-[64px] border-t border-[#e0e0e0] p-[12px_16px] flex items-center gap-3"
              v-if="userType !== 'Coordenador'"
            >
              <input
                v-model="novoComentario"
                type="text"
                placeholder="Adicionar comentário de revisão..."
                class="flex-1 h-[38px] border border-[#d1d7e2] rounded-full px-[18px] outline-none text-[11px]"
                @keydown.enter.prevent="enviarComentario"
              />

              <button
                class="w-[42px] h-[42px] border-0 rounded-full bg-[#004984] cursor-pointer flex items-center justify-center"
                @click="enviarComentario"
              >
                <v-icon color="white">mdi-send</v-icon>
              </button>
            </div>
          </aside>
        </section>

        <v-snackbar
          v-model="snackbar"
          :color="
            tipoMensagem === 'error'
              ? 'red'
              : tipoMensagem === 'success'
              ? 'green'
              : 'orange'
          "
          :timeout="4000"
          top
          right
        >
          {{ mensagemRetorno }}
          <template #action="{ attrs }">
            <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
              Fechar
            </v-btn>
          </template>
        </v-snackbar>
      </div>
    </v-main>
  </v-app>
</template>

<script>
import axios from 'axios';

import store from '@/store/store';

const API_URL = process.env.VUE_APP_API_URL || 'http://localhost:3000';

export default {
  name: 'TelaRevisaoRoteiros',

  data() {
    return {
      idRoteiro: 1,
      idUsuario: Number(localStorage.getItem('idUsuario')) || 1,
      userType: localStorage.getItem('funcao') || '',
      snackbar: false,
      isLoading: false,
      comentarios: [],
      projeto: {
        nome: 'Carregando...',
        validacao: 'Carregando...',
        descricao: 'Carregando...',
      },
      ator: { nome: 'Carregando...' },
      mensagemRetorno: '',
      tipoMensagem: 'success',
      novoComentario: '',
      minimizouComentarios: false,
      roteiro: {
        titulo: 'Roteiro de validação - Carregando...',
        link: 'Carregando...',
      },
      funcionalidades: [],
    };
  },

  watch: {
    mensagemRetorno(val) {
      if (val) {
        this.snackbar = true;
      }
    },
  },

  mounted() {
    this.idRoteiro = this.$route.params.idRoteiro || this.idRoteiro;
    this.idProjeto = this.$route.params.idProjeto || null;
    this.fetchRoteiroData();
  },

  methods: {
    async fetchRoteiroData() {
      this.isLoading = true;
      try {
        const response = await axios.get(
          `${API_URL}/api/v1/roteiros/${this.idRoteiro}`,
          {
            headers: {
              Authorization: `Bearer ${store.state.token}`,
            },
          },
        );
        const data = response.data;
        this.idProjeto = data.id_projeto;
        this.projeto.nome = data.tb_projeto?.nome || 'Projeto Desconhecido';
        this.projeto.validacao =
          data.tb_escopo_teste?.[0]?.tb_escopo?.tb_validacao?.nome_validacao ||
          'Validação Desconhecida';
        this.projeto.descricao =
          data.tb_projeto?.descricao || 'Descrição do projeto';
        this.ator.nome = data.tb_ator?.nome_ator || 'Ator Desconhecido';

        this.roteiro.titulo = `Roteiro de validação - ${this.ator.nome}`;
        this.roteiro.link = data.link_acesso || 'Sem link disponível';

        if (data.tb_escopo_teste && data.tb_escopo_teste.length > 0) {
          this.funcionalidades = data.tb_escopo_teste.map((escopo, index) => ({
            id: escopo.id_escopo_teste,
            titulo: escopo.tb_escopo?.funcionalidade || `Teste #${index + 1}`,
            objetivo: escopo.tb_escopo?.objetivo || 'Instrução do teste',
            comoAcessar: escopo.tb_escopo?.como_acessar || 'Não especificado',
            imagens: escopo.tb_escopo?.tb_imagem_acesso || [],
            descricao: escopo.o_que_deve_testar,
          }));
        } else {
          this.funcionalidades = [];
        }

        if (data.tb_comentario_roteiro) {
          this.comentarios = data.tb_comentario_roteiro.map((c) => {
            const nome = c.tb_usuario?.nome || 'Usuário';
            const roleDb = c.tb_usuario?.tb_membro?.[0]?.forma_atuacao;
            let roleDisplay = '';

            if (roleDb === 'DESENVOLVEDOR') {
              roleDisplay = ' - Equipe Autora';
            } else if (roleDb === 'QA_TESTADOR' || roleDb === 'TESTADOR') {
              roleDisplay = ' - Equipe QA';
            } else if (roleDb === 'SCRUM_MASTER') {
              roleDisplay = ' - Scrum Master';
            }

            return {
              // eslint-disable-next-line camelcase
              id_comentario: c.id_comentario,
              autor: `${nome}${roleDisplay}`,
              texto: c.comentario,
            };
          });

          this.scrollToBottom();
        }
      } catch (error) {
        console.error('Erro ao buscar dados do roteiro:', error);
        this.tipoMensagem = 'error';
        this.mensagemRetorno = 'Erro ao carregar dados do roteiro.';
      } finally {
        this.isLoading = false;
      }
    },
    solicitarCorrecoes() {
      this.atualizarStatusRoteiro('PRECISA_CORRECAO');
    },

    aprovarRoteiro() {
      this.atualizarStatusRoteiro('VALIDO');
    },

    irParaEdicao() {
      if (this.idProjeto && this.idRoteiro) {
        this.$router.push(
          `/projects/${this.idProjeto}/roteiros/${this.idRoteiro}/edit`,
        );
      } else {
        this.tipoMensagem = 'error';
        this.mensagemRetorno = 'Erro ao identificar o projeto do roteiro.';
      }
    },

    async atualizarStatusRoteiro(novoStatus) {
      try {
        await axios.patch(
          `${API_URL}/api/v1/roteiros-validacao/${this.idRoteiro}`,
          {
            idUsuario: this.idUsuario,
            novoStatus,
            comentario: this.novoComentario,
          },
          {
            headers: {
              Authorization: `Bearer ${store.state.token}`,
            },
          },
        );

        this.tipoMensagem = 'success';

        if (novoStatus === 'VALIDO') {
          this.mensagemRetorno = 'Roteiro aprovado com sucesso.';
        } else {
          this.mensagemRetorno =
            'Solicitação de correções registrada com sucesso.';
        }

        this.novoComentario = '';
      } catch (error) {
        this.tipoMensagem = 'error';

        if (error.response && error.response.data.message) {
          this.mensagemRetorno = error.response.data.message;

          return;
        }

        this.mensagemRetorno =
          'A validação do roteiro não pôde ser finalizada. Tente novamente.';
      }
    },

    async enviarComentario() {
      if (!this.novoComentario.trim()) {
        this.tipoMensagem = 'warning';
        this.mensagemRetorno = 'Digite um comentário antes de enviar.';

        return;
      }

      try {
        const response = await axios.post(
          `${API_URL}/api/v1/roteiros-validacao/${this.idRoteiro}/comentarios`,
          {
            idUsuario: this.idUsuario,
            comentario: this.novoComentario,
          },
          {
            headers: {
              Authorization: `Bearer ${store.state.token}`,
            },
          },
        );

        this.tipoMensagem = 'success';
        this.mensagemRetorno = 'Comentário enviado com sucesso.';

        const nome = response.data.tb_usuario?.nome || 'Você';
        const roleDb = response.data.tb_usuario?.tb_membro?.[0]?.forma_atuacao;
        let roleDisplay = '';

        if (roleDb === 'DESENVOLVEDOR') {
          roleDisplay = ' - Equipe Autora';
        } else if (roleDb === 'QA_TESTADOR' || roleDb === 'TESTADOR') {
          roleDisplay = ' - Equipe QA';
        } else if (roleDb === 'SCRUM_MASTER') {
          roleDisplay = ' - Scrum Master';
        }

        // Adiciona o comentário recém-criado na tela
        this.comentarios.push({
          // eslint-disable-next-line camelcase
          id_comentario: response.data.id_comentario,
          autor: `${nome}${roleDisplay}`,
          texto: response.data.comentario,
        });

        this.novoComentario = '';
        this.scrollToBottom();
      } catch (error) {
        this.tipoMensagem = 'error';
        this.mensagemRetorno = 'Erro ao enviar comentário.';
      }
    },

    goBack() {
      this.$router.push(`/projects/${this.idProjeto}/roteiros`);
    },

    scrollToBottom() {
      this.$nextTick(() => {
        const container = this.$el.querySelector('.comments-body');
        if (container) {
          container.scrollTop = container.scrollHeight;
        }
      });
    },
  },
};
</script>

<style scoped></style>
